import { Icons } from "shared/components/Icons";

export const socials = [
  {
    id: "facebook",

    label: "Facebook",

    tooltip: null,

    href: "https://www.facebook.com/ckziu.wyrzysk",

    external: true,

    visible: {
        desktop: true,
        mobile: true,
    },
    icon: {
      component: Icons.Facebook,

      size: "md",
      offset: {
        x: 0,
        y: 0,
      },
    },
    image: {
        src: "/assets/images/logos/school-site/socials/facebook-logo-height-45px.svg",

        size: "lg",

        height: null,

        offset: {
            x: 0,
            y: 0,
        },
    },
  },
  {
    id: "instagram",

    label: "Instagram",

    tooltip: null,

    href: "https://www.instagram.com/ckziu.wyrzysk/",

    external: true,

    visible: {
        desktop: true,
        mobile: true,
    },
    icon: {
      component: Icons.Instagram,

      size: "md",
      offset: {
        x: 0,
        y: 0,
      },
    },
    image: {
        src: "/assets/images/logos/school-site/socials/instagram-logo-height-45px.svg",

        size: "lg",

        height: null,

        offset: {
            x: 0,
            y: 0,
        },
    },
  },
  {
    id: "tiktok",

    label: "Tiktok",

    tooltip: null,

    href: "https://www.tiktok.com/@ckziu.w.wyrzysku",

    external: true,

    visible: {
        desktop: true,
        mobile: true,
    },
    icon: {
      component: Icons.Tiktok,

      size: "sm",
      offset: {
        x: 0,
        y: 0,
      },
    },
    image: {
        src: "/assets/images/logos/school-site/socials/tiktok-logo-height-45px.svg",

        size: "lg",

        height: null,

        offset: {
            x: 0,
            y: 0,
        },
    },
  },
  {
    id: "youtube",

    label: "Youtube",

    tooltip: null,

    href: "https://www.youtube.com/@ckziuwyrzysk4051",

    external: true,

    visible: {
        desktop: true,
        mobile: true,
    },
    icon: {
      component: Icons.Youtube,

      size: "md",
      offset: {
        x: 0,
        y: 0,
      },
    },
    image: {
        src: "/assets/images/logos/school-site/socials/youtube-logo-height-45px.svg",

        size: "lg",

        height: null,

        offset: {
            x: 0,
            y: 0,
        },
    },
  },
];